import { AdvancedMarker, APIProvider, Map } from "@vis.gl/react-google-maps";
import dayjs from "dayjs";
import { useState } from "react";
import ControlPanel from "../../apuracao/componentes/painelDetalhes/MapControlPanel";

export default function RegistrosRondaMapa({ registros }: iProps) {
    const [mapConfig, setMapConfig] = useState<MapConfig>(MAP_CONFIGS[0]);

    let registrosMapa = false;
    let registroInicial: any = {};
    for (let reg of registros) {
        if (reg.latitude !== null && reg.longitude !== null) {
            registrosMapa = true;
            registroInicial = reg;
            break;
        }
    }
    if (registros.length === 0 || registrosMapa === false) {
        return (
            <div style={{ display: "grid", alignContent: "center", width: "100%", height: "100%", textAlign: "center", fontSize: "1.5em", backgroundColor: "lightgray" }}>
                <p>Nenhum registro encontrado</p>
                <br></br>
                <span className="material-symbols-outlined" style={{ fontSize: "3em" }}>
                    hourglass
                </span>
            </div>
        );
    }

    return (
        <div style={{ width: "100%", height: "100%" }}>
            <APIProvider apiKey={String(process.env.REACT_APP_GOOGLE_MAPS_API_KEY)}>
                <Map
                    mapId={mapConfig.mapId || null}
                    mapTypeId={mapConfig.mapTypeId}
                    style={{ width: "100%", height: "100%" }}
                    defaultCenter={{
                        lat: Number(registroInicial.latitude),
                        lng: Number(registroInicial.longitude),
                    }}
                    defaultZoom={18}
                    gestureHandling={"greedy"}
                    disableDefaultUI={true}
                >
                    <ControlPanel mapConfigs={MAP_CONFIGS} mapConfigId={mapConfig.id} onMapConfigIdChange={(id) => setMapConfig(MAP_CONFIGS.find((s) => s.id === id)!)} />
                    {registros.map((ronda: any, index: any) => {
                        if (ronda.latitude === null) {
                            return "";
                        }
                        let corLegenda = "#264653";
                        if (ronda.modo_registro === "camera") {
                            corLegenda = "#0f9d58";
                        }
                        return (
                            <AdvancedMarker
                                key={index}
                                position={{
                                    lat: Number(ronda.latitude),
                                    lng: Number(ronda.longitude),
                                }}
                            >
                                <div
                                    style={{
                                        width: 8,
                                        height: 8,
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        background: corLegenda,
                                        borderRadius: "50%",
                                        transform: "translate(-50%, -50%)",
                                    }}
                                >
                                    <p
                                        style={{
                                            position: "absolute",
                                            left: "-48px",
                                            top: "8px",
                                            width: "104px",
                                            maxHeight: "25px",
                                            overflowY: "clip",
                                            color: "white",
                                            backgroundColor: "rgba(0,0,0,.2)",
                                            textAlign: "center",
                                        }}
                                    >
                                        {dayjs(ronda.data_criacao).format("DD/MM/YYYY HH:mm:ss")}
                                        <br></br>
                                        {ronda.sub_descricao}
                                    </p>
                                </div>
                            </AdvancedMarker>
                        );
                        // return (
                        //     <AdvancedMarker
                        //         key={index}
                        //         position={{
                        //             lat: Number(ronda.latitude),
                        //             lng: Number(ronda.longitude),
                        //         }}
                        //     >
                        //         <Pin
                        //             background={corLegenda}
                        //             borderColor={"#000000"}
                        //             glyphColor={corLegenda}
                        //             children={
                        // <p
                        //     style={{
                        //         width: "104px",
                        //         maxHeight: "25px",
                        //         overflowY: "clip",
                        //         color: "white",
                        //         backgroundColor: "rgba(0,0,0,.2)",
                        //     }}
                        // >
                        //     {dayjs(ronda.data_criacao).format("DD/MM/YYYY HH:mm:ss")}
                        //     <br></br>
                        //     {ronda.sub_descricao}
                        // </p>
                        //             }
                        //         />
                        //     </AdvancedMarker>
                        // );
                    })}
                </Map>
            </APIProvider>
        </div>
    );
}
interface iProps {
    registros: any[];
}

const MapTypeId = {
    HYBRID: "hybrid",
    ROADMAP: "roadmap",
    SATELLITE: "satellite",
    TERRAIN: "terrain",
};
export type MapConfig = {
    id: string;
    label: string;
    mapId?: string;
    mapTypeId?: string;
    styles?: google.maps.MapTypeStyle[];
};
const MAP_CONFIGS: MapConfig[] = [
    {
        id: "light",
        label: "Normal",
        mapId: process.env.REACT_APP_GOOGLE_MAPS_API_KEY_MAP_ID_RONDA,
        mapTypeId: MapTypeId.ROADMAP,
    },
    {
        id: "satellite",
        label: "Satélite",
        mapId: process.env.REACT_APP_GOOGLE_MAPS_API_KEY_MAP_ID_RONDA,
        mapTypeId: MapTypeId.SATELLITE,
    },
];
